module.exports = __webpack_public_path__ + "static/img/dai_qu_huo.c89783e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/dai_qu_huo.png
// module id = sBOB
// module chunks = 2